import { render, staticRenderFns } from "./EllipsisLabel.vue?vue&type=template&id=59276b0a&"
import script from "./EllipsisLabel.vue?vue&type=script&lang=js&"
export * from "./EllipsisLabel.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports